import type { IsSameBoard, NormalizeBoardName } from "./types";

export const normalizeBoardName: NormalizeBoardName = (value) =>
  value
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, " ")
    .trim();

// Whole tokens only, so "V2" never claims "UV2" — a different board on the same floor.
export const isSameBoard: IsSameBoard = ({ board, name, label }) => {
  const wanted = normalizeBoardName(board);
  if (!wanted) return false;
  if (normalizeBoardName(label) === wanted) return true;
  return ` ${normalizeBoardName(name)} `.includes(` ${wanted} `);
};
